import {
  Box,
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Image,
} from '@customerio/pluma-components/react';
import warning from '@/assets/images/warn.svg';

const NotFoundPage = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" h="full" w="full">
      <EmptyState>
        <EmptyStateGraphic>
          <Image src={warning} width={80} height={80} role="presentation" />
        </EmptyStateGraphic>
        <EmptyStateTitle>Whoops!</EmptyStateTitle>
        <EmptyStateDescription>Sorry, but this page doesn't exist :(</EmptyStateDescription>
      </EmptyState>
    </Box>
  );
};

export default NotFoundPage;
